import { string, func, bool } from "prop-types"
import { BlankState } from "components/ui"

const BlankQuestion = ({
  group,
  selectionsUrl,
  attendeeQuestionsUrl,
  navigationPathNew,
  blankStateImageURL,
  navigate,
  isSimpleEvent
}) => {
  const renderPlaceholderText = () => {
    if (isSimpleEvent) {
      return <>You can include up to 5 custom questions during registration.</>
    }
    if (group === "registrant") {
      return (
        <>
          Collect group-level information from the registrant. Registration questions are collected
          once for the entire registration. For attendee-specific questions, use{" "}
          <a href={attendeeQuestionsUrl}>Attendee Questions</a>
        </>
      )
    } else {
      return (
        <>
          Capture essential individual attendee information during the registration process. Ideal
          for details needed before someone can register. In the{" "}
          <a href={selectionsUrl}>selection type settings</a>, you can also specify profile
          information to collect for each attendee.
        </>
      )
    }
  }

  return (
    <BlankState
      imageURL={blankStateImageURL}
      onButtonClick={() => navigate(navigationPathNew)}
      buttonLabel="Add a question"
      dangerouslySetPlaceholderTextHTML
      placeholderText={renderPlaceholderText()}
      helpLinkURL={
        group === "registrant"
          ? "https://pcoregistrations.zendesk.com/hc/en-us/articles/210805017#Questions"
          : "https://pcoregistrations.zendesk.com/hc/en-us/articles/20818109954075-Add-Attendee-Questions#create-questions-0"
      }
      helpLinkText={
        group === "registrant"
          ? " What are registration questions? "
          : " What are Attendee Questions? "
      }
    />
  )
}
BlankQuestion.propTypes = {
  group: string.isRequired,
  selectionsUrl: string,
  attendeeQuestionsUrl: string,
  navigationPathNew: string,
  blankStateImageURL: string,
  navigate: func,
  isSimpleEvent: bool
}

export default BlankQuestion
